import React from 'react';

const ClosingStatement = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-[#0A192F] to-[#172A45] text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <p className="text-[#64FFDA] text-xl lg:text-3xl leading-relaxed text-center">
            I focus on designing and operating automation-ready, highly available network infrastructures—combining solid architecture decisions with real-world operational reliability and measurable SLA improvements.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ClosingStatement;

